import { useContext } from "react";
import { DomainContext } from "../../contexts/user/DomainContext";

const useDomain = () => useContext(DomainContext);

export default useDomain;
